import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormHelperText,
  Grid,
} from "@mui/material";
import { checkUser, getData, updateData } from "../../../Config/FirebaseMethod";

const Accounts = () => {
  const [isloading, setisLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [formData, setFormData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    number: "",
    country: "",
    city: "",
    gender: "",
  });

  const currentStdData = () => {
    checkUser()
      .then((res) => {
        return getData(`AneeqUllahKhan/`, res)
          .then((success) => {
            setisLoading(false);

            setFormData({
              id: success.id || "",
              firstName: success.firstName || "",
              lastName: success.lastName || "",
              number: success.number || "",
              country: success.country || "",
              city: success.city || "",
              gender: success.gender || "",
            });
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSubmit = (event) => {
    setLoading(true);
    event.preventDefault();

    const nodeName = "AneeqUllahKhan";
    const id = formData.id;

    updateData(formData, nodeName, id)
      .then((message) => {
        setMsg(message); // "Update Successfully"
        setLoading(false);
      })
      .catch((err) => {
        setMsg(err);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    currentStdData();
  }, []);

  return (
    <>
      {isloading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  minWidth: 32 + "%",
                  borderRadius: 3,
                }}
              >
                <CardContent>
                  <h4 className="text-center mt-3 mb-4">Account Settings</h4>

                  <Divider />

                  <div className="container mt-5 mb-5">
                    <form onSubmit={handleSubmit}>
                      <div className="row mb-4">
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            First Name *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            last Name *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Phone Number *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="number"
                            value={formData.number}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Country *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="row mb-4">
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            City *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-3">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            Gender
                          </label>
                          <select
                            className="form-select"
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </select>
                        </div>
                      </div>

                      <Button variant="contained" type="submit" color="success">
                        {loading ? <CircularProgress /> : "Change"}
                      </Button>
                    </form>

                    <div className="mt-3">
                      <FormHelperText
                        id="component-error-text"
                        sx={{ color: "green", fontSize: 16 }}
                      >
                        {msg}
                      </FormHelperText>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Accounts;
